import { ContentTypes, HttpHeaders } from '..';

export const executeBaseQuery = async ({ baseQuery, params, url }) => {
  return baseQuery({
    headers: {
      [HttpHeaders.CONTENT_TYPE]: ContentTypes.JSON,
    },
    params,
    url,
  });
};
